export default "__VITE_ASSET__CwX0f92C__"